import React from "react";

import { EtsyChannel } from "../../components/reports";
import { WrapperPage } from "../../components/shared/WrapperPage";

export function EtsyChannelPage() {
    return (
        <WrapperPage>
            <EtsyChannel />
        </WrapperPage>
    );
}
